export default function (pluginsHandler) {
    return {
        name: 'theme-folder',
        style: 'themes/'+ pluginsHandler.getTheme() +'.css',
        rowClasses(tree) {
            return { 
                'folder' : tree.isFolder,
                'expanded' : tree.open && tree.isFolder,
            }
        },
        treeClasses(tree){
            return {
                'oc-tree-folder': true,
                'oc-tree': false
            }
        },
        slotsContent: {
            rowPrepend: `<span class="icon"></span>
                         <span class="title">`,
            rowAfterTitle: `</span>`
        }
    }
}
